import React from 'react';
import { LoginButton_Root, LoginButton_Text, LoginButton_Icon } from './LoginButton.styles';

/** @typedef {React.HTMLAttributes<HTMLButtonElement>} LoginButtonProps */

/** @type {React.FC<LoginButtonProps>} */
export const LoginButton = (props) => {
    return (
        <LoginButton_Root {...props}>
            <LoginButton_Icon />
            <LoginButton_Text>
                Log In or Register
            </LoginButton_Text>
        </LoginButton_Root>
    );
};
